<template>
    <div class="login_container">
        <v-form v-model="valid">
            <v-posts-loader :active="loading ? 'active' : ''"></v-posts-loader>
            <v-container fluid fill-height v-if="!loading">
                <v-row
                    align="center"
                    justify="center"
                    :class="
                        $vuetify.breakpoint.smAndUp ? 'pa-3' : 'pa-3 for_mobile'
                    "
                    :style="$vuetify.breakpoint.smAndUp ? 'padding-top: calc((100vh - 520px)/2) !important' : ''"
                >
                    <v-col
                        cols="12"
                        sm="8"
                        md="5"
                        class="
            px-10
            py-10
            login_card
            text-center
            d-flex
            flex-column
            align-center
            justify-space-between
            m-w-600
            w-100
          "
                    >
                        <div class="col px-0 py-0">
                            <div class="logo">
                                <img src="../assets/logo.svg" alt="logo" />
                            </div>

                            <validation-provider
                                rules="required|email"
                                v-slot="{ errors }"
                            >
                                <v-text-field
                                    class="text_field ml-auto mr-auto mt-4"
                                    label="Email"
                                    color="#fff"
                                    type="email"
                                    flat
                                    solo
                                    height="70"
                                    light
                                    hide-details="auto"
                                    v-model="form.email"
                                    :error="errors.length > 0"
                                    :error-messages="errors"
                                ></v-text-field>
                            </validation-provider>

                            <validation-provider
                                rules="required"
                                v-slot="{ errors }"
                            >
                                <v-text-field
                                    class="text_field ml-auto mr-auto mt-8"
                                    label="Password"
                                    color="#fff"
                                    type="password"
                                    flat
                                    solo
                                    height="70"
                                    light
                                    hide-details="auto"
                                    v-model="form.password"
                                    :error="errors.length > 0"
                                    :error-messages="errors"
                                ></v-text-field>
                            </validation-provider>

                            <div
                                class="
                actions
                ml-auto
                mr-auto
                d-flex
                flex-column flex-md-row
                align-center
                mt-3 mb-6
                justify-md-space-between
              "
                            >
                                <div class="d-flex align-center">
                                    <v-checkbox
                                        id="save_checkbox"
                                        background-color="#fff"
                                        dark
                                        color="#172745"
                                        :ripple="false"
                                        hide-details=""
                                        v-model="form.save_password"
                                    ></v-checkbox>
                                    <label
                                        class="checkbox_label ml-3"
                                        for="save_checkbox"
                                        >Save password</label
                                    >
                                </div>

                                <a
                                    class="mt-4 mt-md-6 mr-md-1"
                                    :href="link_forgot"
                                    >Forgot password</a
                                >
                            </div>
                        </div>

                        <v-btn
                            class="card_btn mb-10"
                            height="70px"
                            width="217px"
                            depressed
                            dark
                            color="#76CD68"
                            @click="handleLogin"
                        >
                            Get it Now
                        </v-btn>
                        <div style="display: flex; justify-content: space-between; width: 100%">
                            <a href="/terms.html">Terms</a>
                            <a href="/privacy.html">Privacy</a>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
    </div>
</template>

<script>
import Vuetify from "vuetify";
import PostsLoader from '../components/PostsLoader.vue';
import { mapActions } from 'vuex'
import { ValidationProvider, extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";

extend("email", { ...email, message: "This field must be email" });
extend("required", { ...required, message: "This field is required" });

export default {
    name: "Login",
    vuetify: new Vuetify(),
    components: {
        ValidationProvider,
       'v-posts-loader': PostsLoader,
    },
    data() {
        return {
            valid: false,
            loading: false,
            link_forgot: "/forgot-password",
            form: {
                email: null,
                password: null,
                save_password: false
            }
        };
    },
    methods: {
        ...mapActions("user", ["login"]),
        handleLogin() {
            if (!this.valid || this.loading) {
                return;
            }
            this.login({ ...this.form })
                .then(() => {
                    this.$router.push({ path: "/dashboard" });
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                    console.log("authentication failed");
                });
        }
    }
};
</script>
<style scoped>
.login_container {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: #2c4370;
}
.m-w-600 {
  max-width: 600px;
}
.v-application .for_mobile .p-b-150 {
  padding-bottom: 150px !important;
}
.for_mobile {
    height: 100vh;
}

.login_card {
    /*height: 90%;*/
    background-color: #eef4ff;
    border-radius: 20px;
}

.text_field {
    max-width: 520px;
}

.v-text-field--outlined >>> fieldset {
    border-radius: 20px;
    background-color: #fff;
}

.text_field >>> .v-label {
    color: #a8b2c5;
    padding: 0px 10px;
    font-size: 18px;
}

.text_field >>> .v-text-field__slot input {
    color: #a8b2c5;
    padding: 0px 10px;
    font-size: 18px;
}

.v-text-field--outlined,
.v-text-field--solo {
    border-radius: 20px;
}

.actions {
    font-size: 18px;
    color: #172745;
}

.actions >>> .v-label {
    font-size: 18px;
    color: #172745;
}

a {
    font-size: 18px;
    color: #172745;
    text-decoration: none;
}

.card_btn {
    border-radius: 40px;
    font-size: 18px !important;
    text-transform: none;
    font-weight: 500;
}

.actions {
    max-width: 520px;
}

.actions >>> .v-input--selection-controls__input {
    margin-right: 0 !important;
    height: 15px;
    width: 15px;
}

.checkbox_label {
    margin-top: 25px;
}
</style>
